export const b2cMsalConfig = {
    auth: {
      clientId: "9b620fce-5738-4510-b4e1-a794aca583a3",
      authority: "https://ClaycoExternalDev.b2clogin.com/ClaycoExternalDev.onmicrosoft.com/B2C_1_si",
      knownAuthorities: ["claycoexternaldev.b2clogin.com"],
      redirectUri: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : ""),
      scopes: ["openid"]
        },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };

  export const b2cProdConfig = {
    auth: {
      clientId: "e9285688-28c1-44de-8788-eb6dfdfcd0c7",
      authority: "https://clayconewhires.b2clogin.com/clayconewhires.onmicrosoft.com/B2C_1_si",
      knownAuthorities: ["clayconewhires.b2clogin.com"],
      redirectUri: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : ""),
      scopes: ["openid"]
        },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };

  export const msalConfig = {
    auth: {
      clientId: "c5f8aabc-62bb-4324-af72-3c07931df741",
      authority: "https://login.microsoftonline.com/3e8dbf1c-34b7-46b7-8972-8605842ef0df",
      redirectUri: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : ""),
      scopes: ["User.Read", "profile", "User.ReadBasic.All"]
        },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };